module.exports = __webpack_public_path__ + "media/v2/components/Contests/shared/Image/targetSuccses-8c9644a6ca748724441926d49eb2f50a.svg";